import { render } from "./MainPopup.vue?vue&type=template&id=36612b3f&scoped=true"
import script from "./MainPopup.vue?vue&type=script&lang=js"
export * from "./MainPopup.vue?vue&type=script&lang=js"

import "./MainPopup.vue?vue&type=style&index=0&id=36612b3f&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36612b3f"]])

export default __exports__